import { Observable } from 'rxjs';

export interface AutoSaveableComponent {
  autoSave(): void;
  autoSaveFromAdminChange(): Observable<boolean>;
}
